import React from "react";
import Button from "@mui/material/Button";
import axios from "axios";
import { useRecoilValue } from "recoil";
import { configState } from "../lib/Store";

function Test() {
  const config = useRecoilValue(configState);
  axios.defaults.withCredentials = true; // 세션유지
  
  const test_session = async () => {    
    // let result = await axios.post("https://api.docircuit.org:3001/hr/test");
    let result = await axios.post("http://localhost:3001/hr/test");
  }

  return (
    <>
      <Button variant="contained" onClick={test_session}>
        클릭
      </Button>
    </>
  );
}
export default Test;
